import { render, staticRenderFns } from "./PrimaryInput.vue?vue&type=template&id=149ca408&scoped=true&"
import script from "./PrimaryInput.vue?vue&type=script&lang=js&"
export * from "./PrimaryInput.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryInput.vue?vue&type=style&index=0&id=149ca408&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149ca408",
  null
  
)

component.options.__file = "PrimaryInput.vue"
export default component.exports